<template>
    <div class="container">
            <o-bread-crumb>
                <template v-slot:pageName>
                    User
                </template>
                <template v-slot:pageDetail>
                    List
                </template>
            </o-bread-crumb>
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div class="main-container">
            <div class="d-flex justify-content-start form-container">
            <o-card :card-title="page.cardTitle" class="custom-table mw-700">
                <o-form @submit.prevent="submit()" autocomplete="off">
                    <o-input-text name="code" v-model="user.id" type="hidden" :required="true" autocomplete="off"/>
                    <!-- Dummy inputs to prevent autofill -->
                    <input type="email" name="fake-email" style="display: none;" autocomplete="off" />
                    <input type="password" name="fake-password" style="display: none;" autocomplete="off" />
                    <o-form autocomplete="off">
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-2 pe-2">
                                <o-form-group title="title" name="title">
                                    <o-select v-model="user.title" :options="titles" autocomplete="'off'"></o-select>
                                </o-form-group>
                            </div>
                            <div class="col-md-5 pe-2">
                                <o-form-group title="first name" name="first_name">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="first_name" :autocomplete="'off'" v-model="user.first_name" type="text" :required="true"/>
                                    <div v-if="validation.first_name" class="error-text">{{ validation.first_name[0] }}</div>
                                </o-form-group>
                            </div>
                            <div class="col-md-5">
                                <o-form-group title="last name" name="last_name">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="last_name" :autocomplete="'off'" v-model="user.last_name" type="text" :required="true"/>
                                    <div v-if="validation.last_name" class="error-text">{{ validation.last_name[0] }}</div>
                                </o-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="email" name="email">
                                    <span class="text-danger"> *</span>
                                    <o-input-text 
                                        name="email" 
                                        :autocomplete="'new-email'" 
                                        v-model="user.email" 
                                        type="email" 
                                        :required="true"
                                        @focus="handleEmailFocus"
                                        @blur="handleEmailBlur"
                                    />
                                    <div v-if="validation.email" class="error-text">{{ validation.email[0] }}</div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="password" name="password">
                                    <span class="text-danger"> *</span>
                                    <o-input-text 
                                        name="password" 
                                        :autocomplete="'new-password'" 
                                        v-model="user.password" 
                                        type="password" 
                                        :required="true"
                                        @focus="handlePasswordFocus"
                                        @blur="handlePasswordBlur"
                                    />
                                    <div v-if="validation.password" class="error-text">{{ validation.password[1] || validation.password[0] }}</div>
                                    <small v-if="page.cardTitle == 'Edit user'" class="form-text text-muted">
                                        If you do not want to change the password, leave this password field empty
                                    </small>
                                </o-form-group>
                                <div class="text-center mb-3">
                                    <p style="font-size: 11px; font-weight:600; color:#878787">* Password at least 6 characters, include uppercase, lowercase, numbers, and special characters</p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group titleBold="User Level" name="level">
                                    <span class="text-danger"> *</span>
                                    <o-select v-model="user.level_ids" autocomplete="'off'" :options="levels"></o-select>
                                    <div v-if="validation.level_ids" class="error-text">{{ validation.level_ids[0] }}</div>
                                </o-form-group>
                            </div>
                            <div v-if="!rootSelected" class="col-md-6">
                                <o-form-group titleBold="User Group" name="entity">
                                    <span class="text-danger"> *</span>
                                    <o-select v-model="user.entity" :required="true" :options="entities" autocomplete="'off'"></o-select>
                                    <div v-if="validation.entity" class="error-text">{{ validation.entity[0] }}</div>
                                </o-form-group>
                            </div>
                        </div>
                        <br>
                        <div v-if="!rootSelected" class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="User Role" name="entity">
                                    <span class="text-danger"> *</span>
                                    <o-select v-model="user.role" :required="true" :options="roles" autocomplete="'off'"></o-select>
                                    <div v-if="validation.role" class="error-text">{{ validation.role[0] }}</div>
                                </o-form-group>
                            </div>
                            <div v-if="user.role" id="button-user-role" class="col-md-6">
                                <o-button type="button" :size="'sm'" :variant="'info'" :white="'white'" @click="roleInfo">{{ selectedUserRoleName }} Role Info</o-button>
                            </div>
                        </div>
                        <!-- <o-button @click="abilitiesModal" :required="true" :size="'sm'" :variant="'success'" :white="'white'" autocomplete="'off'">
                            Set User Permissions
                        </o-button> -->
                        <br>
                        <br>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="phone" name="phone">
                                    <span class="text-danger"> *</span>
                                    <div class="d-flex">
                                        <div style="width: 25%;" v-if="!unknownCountry">
                                          <o-input-text
                                            name="countryCode"
                                            :autocomplete="'off'"
                                            v-model="countryCode"
                                            type="text"
                                            :required="true"
                                            :readonly="true"
                                            :disabled="true"
                                          />
                                        </div>
                                        <div style="width: 100%;">
                                          <o-input-text
                                            name="phone"
                                            :autocomplete="'off'"
                                            v-model="user.phone"
                                            type="text"
                                            :required="true"
                                            :numbers-only="true"
                                          />
                                        </div>
                                      </div>
                                    <div v-if="validation.phone" class="error-text">{{ validation.phone[0] }}</div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="state/province" name="state">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="state" v-model="user.state" type="text" :required="true" autocomplete="'off'"/>
                                    <div v-if="validation.state" class="error-text">{{ validation.state[0] }}</div>
                                </o-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6 me-2">
                                <o-form-group title="city/area" name="city">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="city" v-model="user.city" type="text" autocomplete="'off'"></o-input-text>
                                    <div v-if="validation.city" class="error-text">{{ validation.city[0] }}</div>
                                </o-form-group>
                            </div>
                            <div class="col-md-6">
                                <o-form-group title="post code" name="post code">
                                    <span class="text-danger"> *</span>
                                    <o-input-text name="post code" v-model="user.postcode" type="text" autocomplete="'off'"/>
                                    <div v-if="validation.postcode" class="error-text">{{ validation.postcode[0] }}</div>
                                </o-form-group>
                            </div>
                        </div>
                        <o-form-group title="address" name="address">
                            <o-textarea 
                                name="address"
                                v-model="user.address"
                                placeholder="enter your additional address information"
                                style="height: 45px"
                                for="address"
                                id="address"
                                autocomplete="'off'"
                            ></o-textarea>
                        </o-form-group>
                        <div class="d-flex justify-content-between me-2">
                            <div class="col-md-6">
                                <o-form-group title="country" name="country">
                                    <span class="text-danger"> *</span>
                                    <o-select v-model="user.country" :options="options" autocomplete="'off'"></o-select>
                                    <div v-if="validation.country" class="error-text">{{ validation.country[0] }}</div>
                                </o-form-group>
                            </div>
                        </div>
                        <o-form-group title="avatar" name="avatar" class="pe-2">
                            <br>
                            <div class="default-avatars">
                                <div class="default-avatars">
                                    <img v-for="(avatar, index) in defaultAvatars" 
                                        :key="index" 
                                        :src="avatar" 
                                        @click="selectDefaultAvatar(avatar)" 
                                        :class="{ 'selected-avatar': selectedAvatar === avatar }" 
                                        class="avatar-option">
                                </div>
                                <div class="or-container">
                                    <span class="or-text">or</span>
                                </div>
                            </div>
                            <br>
                            <div>
                                <o-image-input ref="imageInput" name="avatar" id="avatar" :imageurl="image.url" @selectImage="imageHandling"></o-image-input>
                            </div>
                        </o-form-group>
                    </o-form>
                    <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
                    <div class="spinner" v-if='page.isLoading'></div>
                    <div class="button-container mt-3">
                        <o-button type="submit" :size="'sm'" :variant="'primary'" :white="'white'">
                          Save
                        </o-button>
                        <o-button @click="cancel()" :size="'sm'" :variant="'outline-secondary'" :white="'white'">
                          Cancel
                        </o-button>
                    </div>
                </o-form>
            </o-card>
            </div>
            <div v-if="showInfo && !isMobile" class="d-flex info-container">
                <o-card :card-title="'User Role Information'">
                    <div class="row">
                        <div v-for="role in selectedUserRole" :key="role.id" id="box-per-card" class="col-md-6 mb-3">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="card-title">{{ formattedModuleName(role.name) }}</h5>
                                </div>
                                <div class="card-body" id="user-role-card-body">
                                    <p v-if="role.none === 1" class="card-text"><strong>None</strong></p>
                                    <p v-if="role.read === 1" class="card-text"><strong>Read</strong></p>
                                    <p v-if="role.write === 1" class="card-text"><strong>Write</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </o-card>
            </div>
            <!-- <div v-if="showInfo && isMobile" class="d-flex info-container"> -->
                <o-modal v-if="showInfo && isMobile" title="User Role Information"
                    :bodyClass="'custom-modal-body-mobile'"
                    :contentClass="'custom-modal-content-mobile'"
                >
                    <template v-slot:header>
                        <button type="button" class="btn-close" @click="showInfo = false"></button>
                    </template>
                    <template v-slot:body>
                        <div class="row">
                            <div v-for="role in selectedUserRole" :key="role.id" id="box-per-card-mobile" class="col-md-6 mb-3">
                                <div class="card">
                                <div class="card-header">
                                    <h5 class="card-title">{{ formattedModuleName(role.name) }}</h5>
                                </div>
                                <div class="card-body" id="user-role-card-body">
                                    <p v-if="role.none === 1" class="card-text"><strong>None</strong></p>
                                    <p v-if="role.read === 1" class="card-text"><strong>Read</strong></p>
                                    <p v-if="role.write === 1" class="card-text"><strong>Write</strong></p>
                                </div>
                                </div>
                            </div>
                            </div>
                    </template>
                </o-modal>
            <!-- </div> -->
        </div>
    </div>
    <!-- <Modal v-if="showModal" @close="abilitiesModal">
        <template #header>
        <h5 class="modal-title">User and Module Abilities</h5>
        </template>
        <template #body>
        <div class="permissions-container">
            <div class="form-group">
                <div class="label-container">
                    <label class="section-title me-5 pe-4">Module</label>
                    <label class="section-title ms-5 ps-5">Permissions</label>
                </div>
            
            Group for each module and its permissions
            <div v-for="module in modules" :key="module.value" class="permission-row">
                <div class="module-name">{{ formattedModuleName(module.text) }}</div>
                <div class="permission-buttons">
                    <div>
                        <button 
                            :class="['permission-btn', { active: user.abilities[module.value]?.none || !user.abilities[module.value] }]"
                            @click="setAbility(module.value, 'none')">None</button>
                        <button 
                            :class="['permission-btn', { active: user.abilities[module.value]?.read }]"
                            @click="setAbility(module.value, 'read')">Read</button>
                        <button 
                            :class="['permission-btn', { active: user.abilities[module.value]?.write }]"
                            @click="setAbility(module.value, 'write')">Write</button>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </template>
        <template #footer>
        <o-button class="closeModalButton" @click="abilitiesModal" :size="'sm'" :variant="'primary'" :white="'white'">
            Close
        </o-button>
        <o-button class="saveModalButton" @click="saveChanges" :size="'sm'" :variant="'success'" :white="'white'">
            Save Changes
        </o-button>
        </template>
    </Modal> -->
</template>

<script>
import { 
OCard, OForm, OFormGroup, OInputText, 
OButton, OTextarea, OSelect, OImageInput, 
OBreadCrumb, OModal
} from '@/components/OmnihControl';
import { reactive, ref, onMounted, computed, watch, onBeforeUnmount, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js';
import { getCode } from 'country-list';
// import Modal from './Modal.vue';

export default {
name: 'AddUser',
components: {
    OCard,
    OForm,
    OFormGroup,
    OInputText,
    OButton,
    OSelect,
    OTextarea,
    OImageInput,
    OBreadCrumb, 
    OModal
},
// computed: {
//     entityTitle() {
//     const levelNames = this.getLevelNamesByIds([this.user.level_ids]);
//         switch (levelNames[0]) {
//             case 'corporate':
//             return 'Corporate Name';
//             case 'branch':
//             return 'Branch Name';
//             case 'merchant':
//             return 'Merchant Name';
//             default:
//             return 'Entity Name';
//         }
//     }
// },
watch: {
    'user.level_ids'(newValue, oldValue) {
        const levelNames = this.getLevelNamesByIds([newValue]);
        if (levelNames[0] == "root"){
            this.rootSelected = true;
        }else {
            this.rootSelected = false;
        }
        
        if (oldValue != '') {
            this.user.entity = '';
        }
    },
},
methods: {
    getLevelNamesByIds(ids) {
        if (!Array.isArray(ids)) {
            return [];
        }
        return ids.map(id => {
            const level = this.$store.state.Level.levels.find(level => level.id === id);
            return level ? level.name : null;
        }).filter(name => name !== null);
    }
},
setup(){
    const windowWidth = ref(window.innerWidth);
    const isMobile = computed(() => windowWidth.value <= 768);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const store = useStore();

    const page = reactive({
        isLoading: false,
        cardTitle: 'Create User'
    })

    const rootSelected = ref(false);

    const user = reactive({
        title: 'Mr.',
        first_name: '',
        last_name: '',
        id: "",
        corporate_id: "",
        email: "",
        password: "",
        repassword: "",
        level_ids: "",
        level_name: "",
        entity: "",
        avatar: "",
        phone: "",
        address: "",
        state: "",
        country: 0,
        // abilities: {},
        city: "",
        postcode: "",
        role: ''
    });

    const roles = ref([]);

    const image = reactive({
        url: ""
    })
    const titles = ref([
        { value: 'Mr.', text: 'Mr.' },
        { value: 'Mrs.', text: 'Mrs.' },
        { value: 'Miss', text: 'Miss' }
    ]);
    const error = ref(null);

    const options = ref([]);

    const empty = ref([]);

    const validation = ref([]);
    
    const router = useRouter();

    const route = useRoute();

    const levels = computed(() => 
        store.state.Level.levels
            .filter(v => v.name !== "member")
            .map(level => ({ value: level.id, text: level.name }))
    );

    // const modules = computed(() => 
    //     store.state.Module.modules
    //         .map(module => ({ value: module.id, text: module.name }))
    // );

    const entities = ref([])

    const selectedEntity = reactive({
        name:"",
        key:""
    })

    const countryCode = ref('');

    const unknownCountry = ref(false);

    const countries = ref([]);

    const userCountry = ref();

    const showModal = ref(false);

    const imageInput = ref(null);

    const defaultAvatars = [
        'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/woman.png',
        'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/man.png',
    ];

    const selectedAvatar = ref(null);

    const showUpload = ref(false);

    const showInfo = ref(false);

    const selectedUserRole = ref(null);

    const selectedUserRoleName = ref(null);

    onMounted(async () => {
        window.addEventListener('resize', handleResize);
        page.isLoading = true;

        await loadLevels();
        await loadCountries();
        // await loadModules();
        await loadRoles();

        if (route.params.id) {
            await loadState(route.params.id);
        }
        updatePhoneCode();
        user.phone = removeCountryCode(user.phone);

        page.isLoading = false;
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize);
    });

    async function loadCountries() {
        try {
            const response = await store.dispatch('Countries/read');
            countries.value = response.map(country => ({ value: country.id, text: country.name }));
            options.value = countries.value;
        } catch (err) {
            console.error(err);
        }
    }

    async function loadState(id) {
        page.isLoading = true; // Set loading to true sebelum memulai pemanggilan API

        try {
            const data = await store.dispatch('User/read_single', id);
            const { title, first_name, last_name, email, levels, user_profile, roles } = data;
            const { phone, address, state, country, avatar, city, postcode } = user_profile;

            Object.assign(user, {
                id: data.id,
                title,
                first_name,
                last_name,
                level_ids: levels[0]?.id,
                email,
                phone,
                address,
                state,
                country,
                entity: data.branches[0]?.id || data.corporates[0]?.id || data.merchants[0]?.id,
                role: roles[0]?.role_name,
                city,
                postcode
            });

            image.url = avatar?.image_url;
            page.cardTitle = 'Edit user';
        } catch (error) {
            console.error('Error loading state:', error);
        } finally {
            page.isLoading = false; // Set loading to false setelah pemrosesan selesai
        }
    }

    async function loadLevels() {
        return store.dispatch('Level/read');
    }

    // async function loadModules() {
    //     return store.dispatch('Module/read');
    // }

    async function loadRoles() {
        const { corporate_id } = await store.dispatch('Auth/getBusinessProfile');
        await store.dispatch('Role/read_all', corporate_id);
        roles.value = store.state.Role.roles.map(entity => ({ value: entity.id, text: entity.name }));
    }
    async function loadCorporates() {
        await store.dispatch('Corporate/readAll');
        const activeEntity = localStorage.getItem('profile_name');
        const filteredEntities = store.state.Corporate.corporates.map(entity => ({ value: entity.id, text: entity.name }));
        entities.value = filteredEntities.filter(entity => entity.text === activeEntity);
    }
    async function loadBranches() {
        const { corporate_id } = await store.dispatch('Auth/getBusinessProfile');

        store.dispatch('Branch/read_all', corporate_id).then((resp) => {
            entities.value = resp.map(entity => ({
                value: entity.id,
                text: entity.name,
                status: entity.deleted_at ? 'Inactive' : 'Active'
            }));
        });
    }

    async function loadMerchants() {
        const { branch_id, corporate_id } = await store.dispatch('Auth/getBusinessProfile');
        const filter = branch_id ? { branch_id } : { corporate_id };

        if (filter.branch_id) {
            store.dispatch('Merchant/read_all_branch', filter.branch_id).then((resp) => {
                entities.value = resp.map(entity => ({ 
                    value: entity.id,
                    text: entity.name,
                    status: entity.deleted_at ? 'Inactive' : 'Active'
                }));
            });
        } else if (filter.corporate_id) {
            store.dispatch('Merchant/read_all_corporate', filter.corporate_id).then((resp) => {
                entities.value = resp.map(entity => ({ 
                    value: entity.id,
                    text: entity.name,
                    status: entity.deleted_at ? 'Inactive' : 'Active'
                }));
            });
        }
    }
    function imageHandling(img) {
        user.avatar = img;
        image.url = img;
        selectedAvatar.value = img;
    }

    function selectDefaultAvatar(img) {
        user.avatar = img;
        image.url = img;
        selectedAvatar.value = img;
        imageInput.value.clear();
    }

    function toggleUpload() {
        showUpload.value = !showUpload.value;
    }

    async function submit() {
        page.isLoading = true;
        validation.value = {};
        let hasFEError = false;

        // --- Front-end mandatory field validation ---
        if (!user.first_name) { validation.value.first_name = ["The first name field is required."]; hasFEError = true; }
        if (!user.last_name) { validation.value.last_name = ["The last name field is required."]; hasFEError = true; }
        if (!user.email) { validation.value.email = ["The email field is required."]; hasFEError = true; }
        if (!user.password && route.name === 'UserForm') { validation.value.password = ["The password field is required."]; hasFEError = true; }
        if (!user.level_ids) { validation.value.level_ids = ["The user level field is required."]; hasFEError = true; }
        if (!rootSelected.value && !user.entity) { validation.value.entity = ["The user group field is required."]; hasFEError = true; }
        if (!rootSelected.value && !user.role) { validation.value.role = ["The user role field is required."]; hasFEError = true; }
        if (!user.phone) {
            validation.value.phone = ["The phone field is required."];
            hasFEError = true;
        } else if (user.phone.length < 4) {
            validation.value.phone = ["The phone must be at least 4 digits."];
            hasFEError = true;
        }
        if (!user.state) { validation.value.state = ["The state field is required."]; hasFEError = true; }
        if (!user.city) { validation.value.city = ["The city field is required."]; hasFEError = true; }
        if (!user.postcode) { validation.value.postcode = ["The post code field is required."]; hasFEError = true; }
        if (!user.country) { validation.value.country = ["The country field is required."]; hasFEError = true; }

        if (hasFEError) {
            page.isLoading = false;
            nextTick(() => {
                const firstError = document.querySelector('.error-text');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                    scrollToTop();
                }
            });
            return;
        }

        try {
            // Get business profile
            const resp = await store.dispatch('Auth/getBusinessProfile');
            const { corporate_id } = resp;

            // Format phone number
            user.phone = removeCountryCode(user.phone);

            // Prepare data for create/update
            const action = route.name !== 'UserForm' ? 'User/update' : 'User/create';
            const data = {
                ...user,
                ...(user.avatar ? { avatar: user.avatar } : {}),
                corporate_id
            };

            // Remove role if updating and level is root
            if (action === 'User/update') {
                // Find the level name from level_ids
                let levelName = null;
                const levelObj = store.state.Level.levels.find(level => level.id == data.level_ids);
                if (levelObj) {
                    levelName = levelObj.name;
                }

                if (levelName === 'root') {
                    delete data.role;
                }
            }

            // Create/update user
            const userResp = await store.dispatch(action, { data });

            if (action === 'User/update') {
                // Assign entity to user
                const entity = { ...selectedEntity, id: user.entity };
                await store.dispatch('User/assign', {
                    user: userResp.data.data,
                    entity
                });
                router.push({ name: 'User' });
            } else {
                // For new user creation, redirect to last page
                router.push({ name: 'User', query: { newItem: 'true' } });
            }
        } catch (err) {
            user.phone = removeCountryCode(user.phone);
            if (err.response?.data?.error) {
                if (typeof err.response.data.error === 'string') {
                    try {
                        validation.value = JSON.parse(err.response.data.error);
                        error.value = null;
                    } catch {
                        error.value = err.response.data.error;
                        validation.value = {};
                    }
                } else if (typeof err.response.data.error === 'object') {
                    validation.value = err.response.data.error;
                    error.value = null;
                } else {
                    validation.value = {};
                    error.value = null;
                }
            } else {
                validation.value = {};
                error.value = null;
            }
            nextTick(() => {
                const firstError = document.querySelector('.error-text');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
            scrollToTop();
                }
            });
        } finally {
            page.isLoading = false;
        }
    }
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    function loadEntities(entityType) {
        const entityActions = {
            corporate: loadCorporates,
            branch: loadBranches,
            merchant: loadMerchants
        };
        return entityActions[entityType]?.();
    }
    watch(() => user.level_ids, (newId) => {
        const selectedLevel = levels.value.find(level => level.value == newId);
        if (!selectedLevel) return;

        const entityParams = {
            corporate: ['corporates', 'corporates_id'],
            branch: ['branches', 'branches_id'],
            merchant: ['merchants', 'merchants_id'],
        };
        const entityParam = entityParams[selectedLevel.text];
        if (!entityParam) {
            console.error('store path unset', { selectedLevel });
            return;
        }

        selectedEntity.name = entityParam[0];
        selectedEntity.key = entityParam[1];
        loadEntities(selectedLevel.text);
    });


    function removeCountryCode(phone) {
        const countryName = countries.value.find(country => country.value === parseInt(user.country));
        if (countryName) {
            userCountry.value = countryName;
            const code = getCode(userCountry.value.text);
            if (isSupportedCountry(code)) {
                unknownCountry.value = false;
                const phoneCode = getCountryCallingCode(code);
                if (phoneCode) {
                    const countryCodePattern = new RegExp(`^\\+${phoneCode}`);
                    return phone.replace(countryCodePattern, '').trim();
                }
            } else {
                unknownCountry.value = true;
                console.error(`Unknown country: ${userCountry.value.text}`);
            }
        } else {
            unknownCountry.value = true;
            console.error(`Country not found for user country: ${user.country}`);
        }
        return phone;
    }

    function updatePhoneCode() {
        if (!countries.value || countries.value.length === 0) {
            console.error('Countries data is not loaded yet.');
            return;
        }
        
        const countryName = countries.value.find(country => country.value === parseInt(user.country));
        
        if (countryName) {
            userCountry.value = countryName;
            const code = getCode(userCountry.value.text);
            if (isSupportedCountry(code)) {
                unknownCountry.value = false;
                const phoneCode = getCountryCallingCode(code);
                if (phoneCode) {
                    countryCode.value = `+${phoneCode} `;
                }
            } else {
                unknownCountry.value = true;
                console.error(`Unknown country: ${userCountry.value.text}`);
            }
        } else {
            unknownCountry.value = true;
            console.error(`Country not found for user country: ${user.country}`);
        }
    }

    function cancel() {
        router.push({ name: 'User' });
    }

    // const setAbility = (module, ability) => {
        
    //     if (!user.abilities[module]) {
    //         user.abilities[module] = { none: true, read: false, write: false };
    //     }
    //     user.abilities[module] = {
    //         none: ability === 'none',
    //         read: ability === 'read' || ability === 'write',
    //         write: ability === 'write',
    //     };
    // };

    // async function abilitiesModal() {
    //     showModal.value = !showModal.value;
        
    //     if (showModal.value) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = 'scroll';
    //     }
    // }

    // const saveChanges = () => {
    //     showModal.value = false;
    //     document.body.style.overflow = 'scroll';
    // };

    const formattedModuleName = (name) => {
        return name
            .replace(/[-_]/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
    };

    const roleInfo = () => {
        console.log('Role Info button clicked');
        showInfo.value = !showInfo.value;
        // Tambahkan logika yang diinginkan di sini
    };

    // Autofill handlers
    const handleEmailFocus = (event) => {
        // Enable autocomplete when user clicks on email field
        event.target.setAttribute('autocomplete', 'email');
    };

    const handleEmailBlur = (event) => {
        // Disable autocomplete when user leaves email field
        event.target.setAttribute('autocomplete', 'new-email');
    };

    const handlePasswordFocus = (event) => {
        // Enable autocomplete when user clicks on password field
        event.target.setAttribute('autocomplete', 'current-password');
    };

    const handlePasswordBlur = (event) => {
        // Disable autocomplete when user leaves password field
        event.target.setAttribute('autocomplete', 'new-password');
    };
    
    watch(() => user.country, updatePhoneCode);

    watch(() => user.role, (selectedNewUserRole) => {
        if (selectedNewUserRole !== undefined) {
            const selectedRole = store.state.Role.roles.find(role => role.name == selectedNewUserRole);
            if (selectedRole) {
                selectedUserRoleName.value = selectedNewUserRole;
                selectedUserRole.value = selectedRole.modules;
            }
        }
    });

    return {
        user,
        validation,
        router,
        options,
        route,
        submit,
        entities,
        selectedEntity,
        empty,
        members:computed(()=>store.state.Member.members),
        page,
        imageHandling,
        levels,
        image,
        error,
        rootSelected,
        titles,
        countryCode,
        unknownCountry,
        countries,
        cancel,
        // modules,
        // saveChanges,
        showModal,
        // setAbility,
        // abilitiesModal,
        formattedModuleName,
        defaultAvatars,
        selectedAvatar,
        showUpload,
        selectDefaultAvatar,
        imageInput,
        toggleUpload,
        roles,
        roleInfo,
        showInfo,
        selectedUserRole,
        selectedUserRoleName,
        isMobile,
        handleEmailFocus,
        handleEmailBlur,
        handlePasswordFocus,
        handlePasswordBlur
    }
}
}
</script>

<style scoped>
.main-container {
display: flex;
justify-content: space-between;
}

.form-container, .info-container {
height: 100%; /* Atur tinggi sesuai kebutuhan */
}

.info-container {
display: flex;
align-items: center;
justify-content: center;
max-width: 450px;
}

.permissions-container {
display: flex;
flex-direction: column;
}

.section-title {
font-weight: bold;
margin-top: 2px;
margin-bottom: 2px;
}

.permission-row {
display: flex;
justify-content: space-between;
align-items: center;
padding: 9px 0;
border-bottom: 1px solid #e0e0e0;
}

.module-name {
font-size: 13px;
font-weight: 500;
}

.permission-buttons {
display: flex;
gap: 8px;
}

.permission-btn {
padding: 1px 15px;
border: 1px solid #ccc;
border-radius: 5px;
background-color: white;
font-size: 13px;
cursor: pointer;
transition: background-color 0.2s ease;
}

.permission-btn.active {
background-color: #007bff;
color: white;
}

.permission-btn:hover:not(.active) {
background-color: #f0f0f0;
}

.modal-title {
font-size: 1.2em;
text-align: center;
}
@media (max-width: 600px) {
.modal-title {
  font-size: 1.2em;
  text-align: center;
}

.permissions-container {
  padding: 10px;
}

.label-container {
  flex-direction: column;
  align-items: flex-start;
  display: none;
}

.section-title {
  margin: 5px 0;
}

.permission-row {
  flex-direction: column;
  align-items: flex-start;
}

.module-name {
  font-size: 1em;
  margin-bottom: 5px;
}

.permission-buttons {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.permission-btn {
  width: 100%;
  margin-bottom: 5px;
}

.o-button {
  width: 100%;
  margin-top: 10px;
}
}

@media (max-width: 240px) and (max-height: 320px) {
.modal-title {
    font-size: 0.8em;
    text-align: center;
}

.module-name {
    font-size: 0.8em;
    margin-bottom: 5px;
}

.btn.btn-primary.btn-sm.btn-.text-white.btn-.closeModalButton {
    width: 40%;
    height: 40%;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn.btn-success.btn-sm.btn-.text-white.btn-.saveModalButton {
    width: 40%;
    height: 40%;
    font-size: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}
}

.default-avatars-container {
display: flex;
align-items: center;
}

.default-avatars {
display: flex;
gap: 10px;
}

.or-container {
margin: 0 10px;
align-content: center;
}

.or-text {
display: inline-block;
text-align: center;
font-weight: bold;
}

.avatar-option {
width: 50px;
height: 50px;
cursor: pointer;
border-radius: 50%;
}

.selected-avatar {
outline: 2px solid red;
border-radius: 50%;
}

/* .card-header {
background-color: #f8f9fa;
} */
.card-title {
    margin: 0;
    font-style: normal;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    text-transform: capitalize !important;
}
.card-body#user-role-card-body {
    padding-top: 5px;
}

.card-text {
    font-size: 12px;
    font-style: normal;
    text-transform: lowercase !important;
    font-weight: 200 !important;
}

#box-per-card {
    width: 40% !important;
}

#box-per-card-mobile {
    width: 50% !important;
}

#button-user-role {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
}

.error-text {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
}
</style>